import { BaseZenputCollection, BaseZenputModel } from '../../../backbone-unorganized/shared/forms';

/**
 * A model representing a single action in the toolbarnav.
 */
export const ToolbarNavAction = BaseZenputModel.extend({
    idAttribute: 'container_class',
    defaults: {
        container_class: '', // unique attribute; ID - this is what click events should be bound to
        icon_class: '', // the class of the icon to display
        text: '', // the text to display if the action is displayed in the overflow menu
        display: 'overflow' // either 'icon' or 'overflow'. Only 1 'icon' is allowed per Nav, so 'icon' may be forced as 'overflow' if not enough room
    }
});

export const ToolbarNavActions = BaseZenputCollection.extend({
    model: ToolbarNavAction
});

/**
 * A model representing a single select option in the toolbarnav.
 */
export const ToolbarNavHeaderSelectOption = BaseZenputModel.extend({
    defaults: {
        value: null,
        display_value: null,
        is_selected: false
    }
});

export const ToolbarNavHeaderSelectOptions = BaseZenputCollection.extend({
    model: ToolbarNavHeaderSelectOption
});
